module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"N":"Domestics","U":"Abroad","I":"Import","E":"Eksport","title":"Ordertype convert"},"no":{"N":"Innland","U":"Utland","I":"Import","E":"Eksport","title":"Konverter oppdragstyper"}}')
  delete Component.options._Ctor
}
